import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@/ds";

/**
 * The 56px header a Panel section wears below 992px: "‹ Panel" on the left in a
 * 44px target, the section's title centred (SPEC_NAVEGACION_MOVIL, "Sección
 * interna"). The tab bar stays, with Menú active.
 *
 * The title is centred against the WHOLE header, so the right margin offsets
 * the back button's width — the mockup's `margin-right:74px`. Without it the
 * title reads as left-of-centre on every screen.
 *
 * `right` is the optional end of the row (T14-M1: the notification bell), and
 * it moves that offset. The 74px assumes nothing but the back button occupies
 * width; a slot on the right takes its own width plus one of the row's 8px
 * gaps back off the compensation, so the title stays centred against the header
 * rather than against what is left of it. The bell is 36px — `p-2` around a
 * 20px icon — so the offset becomes 74 − (36 + 8) = 30.
 */

/** The bell's rendered width, and the row's gap. Written here because the
 *  centring arithmetic above is the only thing that reads them. */
const RIGHT_SLOT = 36;
const GAP = 8;

export default function MobileSectionHeader({ titleKey, right = null }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div
      data-testid="panel-section-header"
      style={{
        height: "var(--topbar-height)", display: "flex", alignItems: "center", gap: GAP,
        padding: "0 8px", borderBottom: "1px solid var(--sand)",
        background: "var(--bg-page)",
      }}
    >
      <button
        type="button"
        onClick={() => navigate("/panel")}
        data-testid="panel-back"
        style={{
          height: 44, display: "flex", alignItems: "center", gap: 2,
          padding: "0 8px", border: "none", background: "transparent",
          cursor: "pointer", color: "var(--worker)",
          font: "600 16px var(--font-display)",
        }}
      >
        <Icon name="chevron-left" size={22} />
        {t("nav.dashboard")}
      </button>
      <span
        style={{
          flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
          font: "700 17px var(--font-display)", color: "var(--worker)",
          marginRight: right ? 74 - (RIGHT_SLOT + GAP) : 74, minWidth: 0,
        }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {t(titleKey)}
        </span>
      </span>
      {right ? <div style={{ flexShrink: 0, display: "flex" }}>{right}</div> : null}
    </div>
  );
}
